import React from 'react';

import { CDashboard } from 'components/Visualization';

import { inventorySummaryWidgets } from './config';

export const DataSummary = () => {
  return <CDashboard dashboardWidgets={inventorySummaryWidgets} />;
};
